import { YearEndRxUnfinishedValueDto } from "../../../../api-client";
import { useEffect, useState, useMemo } from 'react';
import useStore from "../../../../helpers/useStore";
import { BIContext } from "../../../../stores/BIDashboard/biDashboard.provider";

const useYearEndRxUnfinishedValues = (startDate: Date, endDate: Date) => {
  const BIStore = useStore(BIContext); 
  const { getYearEndRxUnfinishedValues } = BIStore; 

  const [yearEndRxUnfinishedValues, setYearEndRxUnfinishedValues] = useState<YearEndRxUnfinishedValueDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        const response = await getYearEndRxUnfinishedValues(startDate, endDate);
        
        if (response && response.length > 0) {
          setYearEndRxUnfinishedValues(response);
        } else {
          // console.log("[Total Appointment Value] No data found for the specified range.");
          setYearEndRxUnfinishedValues([]);
        }
      } catch (error) {
        // console.log("Error fetching year's end values: ", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData(); 
  }, [startDate, endDate]);

  return { yearEndRxUnfinishedValues, isLoading };
};

export default useYearEndRxUnfinishedValues;
